import styled from "styled-components";
import Variables from "../../../assets/styleVariables";

export const HeaderContainer = styled.div`
  z-index: 99999;
  width: 100%;
  height: 64px;
  //position: absolute;
  position: fixed;
  padding: 0 12px 0 20px;
  top: 0;
  right: 0;
  background-color: ${Variables.colors.complementary};
  ${props => !props.borderless && `border-bottom: 1px solid ${Variables.colors.complementary_400};`};
  display: flex;
  justify-content: space-between;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  -webkit-align-items: center;
  -ms-flex-align: center;
  .left-side {
    display: flex;
    position: absolute;
    left: 20px;
    top: calc(50% - 20px);
    justify-content: space-between;
    align-items: center;
    .separator {
      width: 1px;
      height: 26px;
      background-color: ${Variables.colors.complementary_400};
    }
    i.left-side-icon {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 0 0 8px;
      cursor: pointer;
      &:before {
        color: ${Variables.colors.complementary_700};
        margin-left: 0;
        font-size: 24px;
      }
      &.pressed, &:hover {
        background-color: ${Variables.colors.complementary_300};
      }
    }
    .profile {
    	position: relative;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-right: 9px;
      min-width: 72px;
      .profile-project-name {
        font-size: ${Variables.font_sizes.x_medium};
        color: ${Variables.colors.primary_vivid};
        margin-bottom: 3px;
        max-width: 150px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .profile-user-name {
        font-size: ${Variables.font_sizes.x_small};
        color: ${Variables.colors.complementary_800};
        max-width: 150px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      i.profile-icon {
      	width: 40px;
				height: 40px;
				border-radius: 50%;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
        margin: 0 4px 0 0 !important;
        &:before {
          margin-left: 0;
          font-size: 8px;
          color: ${Variables.colors.complementary_800};
        }
        &.pressed:not(.disable), &:not(.disable):hover {
          background-color: ${Variables.colors.complementary_300};
        }
        &.disable:before {
          color: ${Variables.colors.complementary_500};          
        }
      }
    }
    .notifications{
      position: relative;
      i.left-side-icon{
        &.pressed, &:hover{
          background-color: ${Variables.colors.complementary_300};
        }
      }
      
    }
    .sidebar-badge {
				background-color: ${Variables.colors.red_600};
				position: absolute;
				width: 16px;
        height: 16px;
        border-radius: 32px;
        top: 4px;
        right: 6px;
				span {
					display: flex;
          justify-content: center;
          align-items: center;
          font-size: ${Variables.font_sizes.x_small};
          width: 100%;
          height: 100%;
          font-family: Number, sans-serif;
          color: ${Variables.colors.complementary};
          text-align: center;
        }
      }
    }
  }
  .right-side {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    right: 12px;
    top: calc(50% - 20px);
    i.right-side-icon {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 0 0 8px;
      cursor: pointer;
      &:before {
        color: ${Variables.colors.complementary_700};
        margin-left: 0;
        font-size: 24px;
      }
      &:hover {
        background-color: ${Variables.colors.complementary_300};
      }
    }
  }
`;